// @ts-strict

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IProduct } from '@app/core/models/core-models';
import { defaultImage } from '@app/core/helpers/constants';

@Component({
  selector: 'app-single-product',
  templateUrl: './single-product.component.html',
  styleUrls: ['./single-product.component.scss']
})
export class SingleProductComponent {
  @Input() productData?: IProduct;
  @Output() isProductSelected = new EventEmitter<boolean>();
  @Output() selectedProductData = new EventEmitter<IProduct>();

  public readonly defaultImage = defaultImage;

  public productSelected(): void {
    if (this.productData) {
      this.selectedProductData.emit(this.productData);
      this.isProductSelected.emit(true);
    } else {
      this.isProductSelected.emit(false);
    }
  }
}
